var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2445 4160 c-92 -15 -155 -36 -256 -86 -77 -39 -109 -63 -189 -143 -87 -86 -103 -107 -148 -201 -67 -136 -85 -215 -85 -360 -1 -145 18 -223 84 -357 100 -203 286 -355 508 -415 99 -27 284 -29 386 -4 283 68 522 308 592 593 24 100 22 286 -5 384 -74 274 -301 501 -568 569 -93 24 -235 33 -319 20z m255 -232 c197 -46 373 -224 421 -428 16 -69 16 -188 0 -260 -48 -207 -224 -383 -431 -431 -191 -44 -395 15 -535 156 -112 111 -169 250 -169 405 2 376 345 644 714 558z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1935 2343 c-84 -12 -200 -49 -290 -92 -325 -155 -537 -455 -575 -816 -15 -138 -13 -369 4 -408 21 -50 52 -72 101 -72 52 0 90 30 105 84 5 20 10 120 10 222 0 221 14 292 86 439 82 166 261 323 441 385 124 44 176 46 789 42 634 -4 618 -2 760 -67 158 -71 301 -208 378 -362 72 -144 86 -216 86 -437 0 -203 7 -245 46 -282 36 -33 102 -34 138 0 44 41 49 77 43 290 -7 218 -20 296 -69 429 -68 179 -216 369 -367 471 -85 58 -228 124 -326 152 -79 23 -87 23 -705 25 -344 1 -638 -1 -655 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLogo);
export default __webpack_public_path__ + "static/media/AccountLogo.85baeb0923fb6bfc979f2df8e5152cdc.svg";
export { ForwardRef as ReactComponent };